import {Component, OnInit, ViewEncapsulation} from '@angular/core';

import {AlertService, AuthenticationService, TenantService,} from '../../_services/index';

import {UploadStatus} from '../../helpers/index';

import {LoginHelper} from '../../helpers';

import * as _ from "lodash";

import {Router} from '@angular/router';
//import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ComplianceArea, Tenant,} from '../../_models/index';

//const now = new Date();
import {TreeNode} from 'primeng/api';

@Component({
    standalone: false,
  selector: "update-controls",
  templateUrl: 'update.controls.component.html',
  styleUrls: ['./update.controls.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class UpdateControlsComponent implements OnInit {

  loading: boolean;
  tenants: TreeNode[];
  public comment: string;
  selected: any[] = [];

  constructor(
    public tenantService: TenantService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService) {
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
        this.authenticationService.logout();

        return;
    }

    this.tenantService.getAllComplianceAreas().subscribe(tenants => {
      for (let tenant of tenants) {
        tenant.data.key = tenant.tenantId;
        for (let complianceArea of tenant.children) {
          complianceArea.data.key = tenant.tenantId + "_" + complianceArea.data.complianceAreaId;
        }
      }
      this.tenants = tenants;
    });
  }

  getStatus(status: number): string {

      return UploadStatus[status];
  }

  onUpdate() {

    this.loading = true;

    const selectedTenants = [];

    for (let tenant of this.tenants){

      const updatedTenant = new Tenant(tenant.data.tenantId);
      updatedTenant.databaseName = tenant.data.name;
      for (let complianceArea of tenant.children){
        if (this.selected.indexOf(complianceArea) >= 0){
          const updatedComplianceArea = new ComplianceArea(complianceArea.data.name, null);
          updatedComplianceArea.complianceAreaId = complianceArea.data.complianceAreaId;
          updatedComplianceArea.uploadComment = this.comment;
          updatedTenant.complianceAreas.push(updatedComplianceArea);
        }
      }

      if (updatedTenant.complianceAreas.length > 0){
        selectedTenants.push(updatedTenant);
      }
    }

    //console.log(selectedTenants);

    this.tenantService.uploadControls({ tenants: selectedTenants })
        .subscribe(
        data => {
            this.alertService.success('The request of updating controls was created.', true);
            this.router.navigate(['/tenants']);
        },
        error => {

            this.alertService.error(error);
        });

        this.loading = false;
  }
}
